import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import ACResults, { ACResultsProps } from './ac-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/mortgages/amortization-schedule-calculator`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('ac') },
      driverPageName: 'mortgages_amortization_calculator',
    };
  },
};

const ACResultsWrapper = (props: ACResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={ACResults}
    />
  );
};

export default ACResultsWrapper;
